import { render, staticRenderFns } from "./block-map.vue?vue&type=template&id=e0fdd372&scoped=true&"
import script from "./block-map.vue?vue&type=script&lang=jsx&"
export * from "./block-map.vue?vue&type=script&lang=jsx&"
import style0 from "./block-map.vue?vue&type=style&index=0&id=e0fdd372&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0fdd372",
  null
  
)

export default component.exports